export const fr = {
    ristournePastille: "Ristourne",
    ristourneLien: "Plus de détails sur ma ristourne",
};
